// Team-name → emoji mapping used for the Lag 1 (match result) icons.
//
// Keys must match the exact team name returned by API-Football
// (e.g. fixture.teams.home.name). When in doubt, fetch a fixture
// from the API once and copy the name verbatim into this map.
//
// Future: replace with real club logos from API-Football's team.logo URL.
// For now we stick to emoji to keep the existing prototype rendering intact.

export const TEAM_ICONS = {
  // ============ Premier League ============
  "Arsenal":             "🔴",
  "Aston Villa":         "🟣",
  "Bournemouth":         "🔴⚫",
  "Brentford":           "🔴⚪",
  "Brighton":            "🔵",
  "Chelsea":             "🔵",
  "Crystal Palace":      "🔴🔵",
  "Everton":             "🔵",
  "Fulham":              "⚪",
  "Liverpool":           "🔴",
  "Manchester City":     "🩵",
  "Manchester United":   "🔴",
  "Newcastle":           "⚫⚪",
  "Nottingham Forest":   "🔴",
  "Tottenham":           "⚪",
  "West Ham":            "🟤",
  "Wolves":              "🟠",

  // ============ La Liga ============
  "Athletic Club":       "🔴⚪",
  "Atletico Madrid":     "🔴⚪",
  "Barcelona":           "🔵🔴",
  "Real Betis":          "🟢",
  "Real Madrid":         "⚪",
  "Real Sociedad":       "🔵⚪",
  "Sevilla":             "⚪🔴",
  "Valencia":            "🟠",
  "Villarreal":          "🟡",

  // ============ Serie A ============
  "AC Milan":            "🔴⚫",
  "Atalanta":            "🔵⚫",
  "Bologna":             "🔴🔵",
  "Fiorentina":          "🟣",
  "Inter":               "🔵⚫",
  "Juventus":            "⚪⚫",
  "Lazio":               "⚪🔵",
  "Napoli":              "🔵",
  "Roma":                "🔴🟡",

  // ============ Bundesliga ============
  "Bayer Leverkusen":    "🔴⚫",
  "Bayern München":      "🔴",
  "Borussia Dortmund":   "🟡⚫",
  "Eintracht Frankfurt": "⚫⚪",
  "RB Leipzig":          "🔴⚪",
  "Stuttgart":           "🔴⚪",
  "Wolfsburg":           "🟢",

  // ============ Superliga ============
  "AaB":                 "🔴⚪",
  "AGF":                 "🟣⚪",
  "Brøndby":             "🟡🔵",
  "FC København":        "🔵⚪",
  "FC Midtjylland":      "⚫⚪",
  "FC Nordsjælland":     "🟡🔴",
  "Lyngby":              "🔵⚪",
  "OB":                  "⚪🔵",
  "Randers":             "🔵⚪",
  "Silkeborg":           "🔵⚪",
  "Sønderjyske":         "🔵",
  "Viborg":              "🟢⚪",

  // ============ National teams (World Cup 2026 + likely qualifiers) ============
  // Names match API-Football's team names — verified against /teams?league=1&season=2022.
  "Algeria":             "🇩🇿",
  "Argentina":           "🇦🇷",
  "Australia":           "🇦🇺",
  "Austria":             "🇦🇹",
  "Belgium":             "🇧🇪",
  "Bolivia":             "🇧🇴",
  "Brazil":              "🇧🇷",
  "Cameroon":            "🇨🇲",
  "Canada":              "🇨🇦",
  "Chile":               "🇨🇱",
  "Colombia":            "🇨🇴",
  "Costa Rica":          "🇨🇷",
  "Croatia":             "🇭🇷",
  "Czech Republic":      "🇨🇿",
  "Czechia":             "🇨🇿",
  "Côte d'Ivoire":       "🇨🇮",
  "Ivory Coast":         "🇨🇮",
  "Denmark":             "🇩🇰",
  "DR Congo":            "🇨🇩",
  "Ecuador":             "🇪🇨",
  "Egypt":               "🇪🇬",
  "England":             "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
  "France":              "🇫🇷",
  "Germany":             "🇩🇪",
  "Ghana":               "🇬🇭",
  "Greece":              "🇬🇷",
  "Hungary":             "🇭🇺",
  "Iceland":             "🇮🇸",
  "Iran":                "🇮🇷",
  "Ireland":             "🇮🇪",
  "Israel":              "🇮🇱",
  "Italy":               "🇮🇹",
  "Japan":               "🇯🇵",
  "Mexico":              "🇲🇽",
  "Morocco":             "🇲🇦",
  "Netherlands":         "🇳🇱",
  "New Zealand":         "🇳🇿",
  "Nigeria":             "🇳🇬",
  "Northern Ireland":    "🏴󠁧󠁢󠁮󠁩󠁲󠁿",
  "Norway":              "🇳🇴",
  "Paraguay":            "🇵🇾",
  "Peru":                "🇵🇪",
  "Poland":              "🇵🇱",
  "Portugal":            "🇵🇹",
  "Qatar":               "🇶🇦",
  "Romania":             "🇷🇴",
  "Saudi Arabia":        "🇸🇦",
  "Scotland":            "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
  "Senegal":             "🇸🇳",
  "Serbia":              "🇷🇸",
  "Slovakia":            "🇸🇰",
  "Slovenia":            "🇸🇮",
  "South Africa":        "🇿🇦",
  "South Korea":         "🇰🇷",
  "Spain":               "🇪🇸",
  "Sweden":              "🇸🇪",
  "Switzerland":         "🇨🇭",
  "Tunisia":             "🇹🇳",
  "Turkey":              "🇹🇷",
  "Türkiye":             "🇹🇷",
  "Ukraine":             "🇺🇦",
  "Uruguay":             "🇺🇾",
  "USA":                 "🇺🇸",
  "United States":       "🇺🇸",
  "Venezuela":           "🇻🇪",
  "Wales":               "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
};

/**
 * Look up the icon emoji for a team. Falls back to a generic
 * home/away icon if the team isn't in the map.
 *
 * @param {string} teamName   - team name as returned by API-Football
 * @param {"home"|"away"} position - which side of the match (for fallback)
 * @returns {string} emoji or fallback
 */
export function getTeamIcon(teamName, position = "home") {
  if (teamName && TEAM_ICONS[teamName]) return TEAM_ICONS[teamName];
  return position === "away" ? "✈️" : "🏠";
}
